import ReactDOM from 'react-dom/client';
import App from './App.tsx';

import { withProfiler, ErrorBoundary } from '@sentry/react';
import { ErrorView } from './components';
import { configureDatadogRum, configureSentry } from './utilities';

configureSentry();
configureDatadogRum();

//Capture performance data in Sentry for the entire app
const AppWithProfiler = withProfiler(App);
export default AppWithProfiler;
AppWithProfiler.displayName = 'AppWithProfiler';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary
    fallback={
      <ErrorView
        message="Error in <App />"
        userMessage="Something went wrong while loading Jane Discovery."
      />
    }
  >
    <AppWithProfiler />
  </ErrorBoundary>
);
